import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { IUserJob } from 'app/ai-job/core/IUserJob';
import { DateUtilDST } from 'app/core/utils/DateUtilDST';
@Component({
  selector: 'job-settings',
  templateUrl: 'job-settings.component.html',
  styleUrls: ['job-settings.component.scss']
})
export class JobSettingsComponent implements OnInit, OnChanges {
  @Input() currentJob: IUserJob;
  @Output() saveJob = new EventEmitter<IUserJob>();
  @Output() cancel = new EventEmitter();

  public dateMax: Date = new Date();
  public showPastDateWarning: boolean = false;

  constructor() {
    this.dateMax.setFullYear(this.dateMax.getFullYear() + 10);
  }

  ngOnInit(): void {
    this.initializeDisplayStartDate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentJob) {
      this.initializeDisplayStartDate();
    }
  }

  changeEnableSchedule() {
    this.currentJob.enabled = !this.currentJob.enabled;
  }

  applyChanges() {
    this.saveJob.emit(this.currentJob);
  }

  public cancelChanges() {
    this.cancel.emit();
  }

  changeFrequency(frequency: string) {
    this.currentJob.schedules[0].frequency.type = frequency;
  }

  onDateChange(newValue: Date) {
    // Reset warnings
    this.showPastDateWarning = false;

    if (this.currentJob.schedules[0].startDate && !this.currentJob.schedules[0].displayStartDate) {
      this.currentJob.schedules[0]['displayStartDate'] = newValue; // raw value for the control
    }

    // Convert and store internally in UTC for the backend
    const d: Date = newValue instanceof Date ? newValue : new Date(newValue);
    const utcDateString = DateUtilDST.returnDateToSave(d);

    this.currentJob.schedules[0].startDate = utcDateString;

    // Check if the selected date is in the past
    this.checkIfDateIsPast(d);
  }

  private initializeDisplayStartDate(): void {
    const schedule = this.currentJob?.schedules?.[0];
    if (schedule?.startDate && !schedule.displayStartDate) {
      schedule.displayStartDate = new Date(DateUtilDST.formatInUserTimezone(schedule.startDate));
    }
    
    // Reset warnings on initialization
    this.showPastDateWarning = false;

    // Check if the current date is in the past
    if (schedule?.displayStartDate) {
      this.checkIfDateIsPast(schedule.displayStartDate);
    }
  }

  private checkIfDateIsPast(date: Date): void {
    this.showPastDateWarning = DateUtilDST.isDateInPast(date);
  }
}
